import { GoogleLogin } from '@react-oauth/google'
import PageHeader from '../components/PageHeader'

function LoginView({ onSuccess, onError }) {
  return (
    <>
      <PageHeader pageName={'Admin Login'} backTo="/" />
      <div
        className="admin-form-container"
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}
      >
        <p style={{ margin: '30px', textAlign: 'center'}}>Please log in with your Google account to access admin features.</p>
        <GoogleLogin onSuccess={onSuccess} onError={onError} />
      </div>
    </>
  )
}

export default LoginView
